import { render, staticRenderFns } from "./default_time.vue?vue&type=template&id=1a96afeb&scoped=true"
import script from "./default_time.vue?vue&type=script&lang=js"
export * from "./default_time.vue?vue&type=script&lang=js"
import style0 from "./default_time.vue?vue&type=style&index=0&id=1a96afeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a96afeb",
  null
  
)

export default component.exports